














































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import TimePicker from "@/components/common/TimePicker.vue";

@Component({
  components: { EditDayChangePicker, TimePicker }
})
export default class BasicInfo7 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() visit_end_status_items!: SelectItem[]; //訪問終了の状況アイテムリスト
  @Prop() die_place_items!: SelectItem[]; //死亡場所リスト
}
